<template>
	<div id="fileuploads">
		<div>
            <div class="row card mt-4" style="padding: 0px;">
				<div class="card-body" style="padding: 20px;">
					<el-form ref="fileuploadForm" label-position="top" :model="file" label-width="120px" @submit.native.prevent >
            <el-form-item label="File Name" prop="FileName"
                          :rules="[{ required: true, message: 'File Name is required', trigger: 'blur'}]"
            >
              <el-input v-model="file.FileName">
              </el-input>
            </el-form-item>
            <el-form-item label="Client File Name" prop="ClientFileName"
                          :rules="[{ required: true, message: 'Client File Name is required', trigger: 'blur'}]"
            >
              <el-input v-model="file.ClientFileName">
              </el-input>
            </el-form-item>
					</el-form>
					<div class="row form-group col-md-12" style="padding-left: 0px;">
						<label class="mb-1 control-label" for="SampleAudio" style="width: 100%;">Sample Audio:</label>
						<form class="form-horizontal fade-in-effect" novalidate method="post" enctype="multipart/form-data">
							<div class="fileinput-button " style="text-align:center;">
								<div id="SampleAudio" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="SampleURL" style="position:relative;" :style="uploadImage">
									<div style="position:absolute;top:8px;left:43px;" v-if="isSaving && whichFile == 'SampleURL'"><i class="fas fa-spinner fa-spin fa-2x"></i> </div>
									<input type="file" id="SampleURLInput" name="SampleURL" :disabled="isSaving" @change="uploadFile($event.target.name)" accept="audio/*" class="input-file">
									<div v-if="RemoveAudio('SampleURL')" class="removeaudio sample" @click.prevent="removeaudio('SampleURL')"><i class="fas fa-times-circle"></i></div>
								</div>
							</div>
						</form>
						<span v-if="file.SampleURL" style="margin-top: 5px; margin-left: 15px; width: 85%;">
							<i v-if="SampleURLPlaying == 'n'" style="cursor:pointer;font-size: 20px;" class="fas fa-play-circle" @click="playSound(file.SampleURL, 'FullURL');SampleURLPlaying = 'y';"></i>
							<i v-else style="cursor:pointer;font-size: 20px;" class="fas fa-pause-circle" @click="stopSound(file.SampleURL);SampleURLPlaying = 'n';"></i>
							<div style="margin-left: 5px; font-size: 12px;display:inline-block; width: 80%;">{{ file.SampleURL}}</div>
						</span>
					</div>
					<div class="row form-group col-md-12" style="padding-left: 0px;">
						<label class="mb-1 control-label" for="FullAudio" style="width: 100%;">Full Audio:</label>
						<form class="form-horizontal fade-in-effect" novalidate method="post" enctype="multipart/form-data">
							<div class="fileinput-button " style="text-align:center;">
								<div id="FullAudio" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="FullURL" style="position:relative;" :style="uploadImage">
									<div style="position:absolute;top:15px;left:53px;" v-if="isSaving && whichFile == 'FullURL'"><i class="fas fa-spinner fa-spin fa-2x"></i> </div>
									<input type="file" id="FullURLInput" name="FullURL" :disabled="isSaving" @change="uploadFile($event.target.name)" accept="audio/*" class="input-file">
									<div v-if="RemoveAudio('FullURL')" class="removeaudio full" @click.prevent="removeaudio('FullURL')"><i class="fas fa-times-circle"></i></div>
								</div>
							</div>
						</form>
						<span v-if="file.FullURL" style="margin-top: 20px; margin-left: 15px; width: 85%;">
							<i v-if="FullURLPlaying == 'n'" style="cursor:pointer;font-size: 20px;" class="fas fa-play-circle" @click="playSound(file.FullURL, 'SampleURL');FullURLPlaying = 'y';"></i>
							<i v-else style="cursor:pointer;font-size: 20px;" class="fas fa-pause-circle" @click="stopSound(file.FullURL);FullURLPlaying = 'n';"></i>
							<span style="margin-left: 5px; font-size: 12px;display:inline-block; width: 80%;">{{ file.FullURL}}</span>
						</span>
					</div>

					<h5>File Properties</h5>
					<strong>Status</strong>
					<el-radio-group v-model="file.Archived" size="default" style="margin-left: 10px;">
						<el-radio-button value="n">Active</el-radio-button>
						<el-radio-button selected value="y">Archived</el-radio-button>
						<el-radio-button value="h">Historical</el-radio-button>
					</el-radio-group>
					<div class="mt-4"><strong>Date/Time File was Posted</strong></div>
					<el-date-picker v-model="file.PostDate" size="default" default-first-option filterable
									type="datetime"
									format="YYYY-MM-DD hh:mm a"
									value-format="YYYY-MM-DD HH:mm:ss"
									placeholder="Post Date">
					</el-date-picker>
					<div class="mt-4"><strong>Specifications</strong></div>
					<el-select key="select1" class="mt-1" size="default" style="width: 120px;margin-right: 5px;" v-model="file.BPMID" placeholder="BPM" default-first-option filterable clearable>
						<el-option
								v-for="item in BPMs"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select2" class="mt-1" size="default" style="width: 200px;margin-right: 5px;" v-model="file.GenreID" placeholder="Genre" default-first-option filterable clearable>
						<el-option
								v-for="item in Genres"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select3" class="mt-1" size="default" style="width: 200px;margin-right: 5px;" v-model="file.MoodID" placeholder="Mood" default-first-option filterable clearable>
						<el-option
								v-for="item in Moods"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select4" class="mt-1" size="default" style="width: 150px;margin-right: 5px;" v-model="file.FormatID" placeholder="Format" default-first-option filterable clearable>
						<el-option
								v-for="item in Formats"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select5" class="mt-1" size="default" style="width: 150px;" v-model="file.LengthID" placeholder="Length" default-first-option filterable clearable>
						<el-option
								v-for="item in Lengths"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
                    <div>
                        <div class="mt-4"><strong>Duration (Seconds)</strong></div>
                        <el-input v-model="file.Duration" class="smallNumber" size="default">
                        </el-input>
                    </div>
                    <div>
						<div class="mt-4"><strong>Clients</strong></div>
						<el-select key="select6" v-model="file.OrganizationIDs" style="width: 100%;" placeholder="Select" multiple default-first-option filterable clearable>
							<el-option
									v-for="item in Organizations"
									:label="item.OrganizationName"
									:value="item.OrganizationID"
									:key="item.OrganizationID">
							</el-option>
						</el-select>
					</div>
				</div>
	        </div>
		</div>
		<div class="row" v-if="(fileData || modifyAccess || createAccess)" >
            <div class="col-12 text-center">
                <button class="btn btn-success btn-icon" @click="save" style="margin-right: 10px;">
                    <i class="fas fa-check"></i> <span> Save Changes</span>
                </button>
                <button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
                    <i class="fas fa-times"></i>  <span>Cancel</span>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
    import Util from '../assets/js/util.js';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				currentStatus : 0,
				uploadReady : true,
				currentFile : '',
				whichFile : '',
				audio : '',
				SampleURLPlaying : 'n',
				FullURLPlaying : 'n',
				file :{FileID: 0, FileName : '', ClientFileName : '', SampleURL : '', FullURL : '', OrganizationIDs : []},
				Organizations : [],
				BPMs : [],
				Genres : [],
				Moods : [],
				Formats : [],
				Lengths: [],
 			}
		},
		name: 'FileUploads',
		props: {
			config : { type: Object },
			fileData : {
				type: [Object,Array],
				required: false,
				default: () => {}
			},
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
	        createAccess () {
				if (this.fileData) {
					return true;
				} else {
			        return Util.createAccess(this.currentUser);
		        }
            },
	        modifyAccess () {
		        if (this.fileData) {
			        return true;
		        } else {
			        return Util.modifyAccess(this.currentUser);
		        }
            },
			defaultImage () {
				return require('../images/file_music-upload-512.png');
			},
			uploadImage() {
				let logo = 'backgroundImage: url(' + this.defaultImage + ')';
				return logo;
			},

		},
		methods: {
			RemoveAudio(whichOne) {
				if (this.file[whichOne]) {
					return true;
				} else {
					return false;
				}
			},
			playSound(file, whichOne) {
				if (this.currentFile) {
					this.stopSound(this.currentFile);
				}
				this[whichOne] = 'n';
				this.currentFile = file;
				this.audio = new Audio(file);
				var playPromise = this.audio.play();

				if (playPromise !== undefined) {
					playPromise.then(_ => {
					})
						.catch(error => {
							console.log(`playSound error: ${error}`);
						});
				}
			},
			stopSound(file, whichOne) {
				this.currentFile = '';
				this[whichOne] = 'n';
				var playPromise = this.audio.pause();

				if (playPromise !== undefined) {
					playPromise.then(_ => {
					})
						.catch(error => {
							console.log(`playSound error: ${error}`);
						});
				}
			},
			reset(showMessage) {
				// reset form to initial state
				if (this.fileData) {
					this.$emit('refreshData');
					this.$emit('close');
				}
				this.currentStatus = STATUS_INITIAL;
				this.getInitialData ();
				this.file = {};

				if (showMessage) {
					this.$notify({
						title: 'Success',
						message: 'Data has been reset',
						type: 'success',
						duration: 1500,
						showClose: false
					});
                 }
			},
			getInitialData () {
				var tables = ['BPMs','Genres','Moods','Lengths','Formats','Organizations'];
				axios.post('/index/tableData', {'tables': tables },
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
						} else {
						}
					}).catch(response => {
				});
			},
			save () {
				this.$refs['fileuploadForm'].validate((valid) => {
					if (valid) {
						if (this.isValid()) {
							if (this.currentStatus == STATUS_SAVING) {
								return true;
							}
							this.currentStatus = STATUS_SAVING;

							axios.post('/files/save', {file: this.file}
							)
								.then(response => {
									if (response.data.result == 'success') {
										this.currentStatus = STATUS_INITIAL;

										this.$notify({
											title: 'Success',
											message: 'File has been saved',
											type: 'success',
											duration: 1500,
											showClose: false
										});
										this.file = {};
										if (this.fileData) {
											this.$emit('refreshData');
											this.$emit('close');
										}
									} else {
										this.currentStatus = STATUS_FAILED;
										this.displayPopup(response.data.message);
									}
								}).catch(response => {
								this.currentStatus = STATUS_FAILED;
							});
						} else {
							this.displayPopup('A File Name and Full Audio File are required.');
						}
					}
				});
			},
			isValid () {
				if (this.file.FileName == '' || this.file.FullURL == '') {
					return false;
				}
				return true;
			},
			uploadFile(fileName) {
				if (this.currentStatus == STATUS_SAVING) {
                    return true;
                }
				this.whichFile = fileName;
				// upload data to the server
				this.currentStatus = STATUS_SAVING;
				axios.post('/index/uploadfile', document.querySelector('#' + fileName + 'Input').files,
					{ headers: { 'Content-Type': 'multipart/form-data'} }
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_SUCCESS;
							this.file[fileName] = response.data.url;
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
						document.getElementById(fileName + 'Input').value = "";
					}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
			removeaudio(whichOne) {
				this.file['whichOne'] = '';
			},

	        displayPopup (message) {
				this.$alert(message,  {
					type: 'error',
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {
		  //set post date to today
      var m = new Date();
      var dateString =
        m.getFullYear() + "/" +
        ("0" + (m.getMonth()+1)).slice(-2) + "/" +
        ("0" + m.getDate()).slice(-2) + " " +
        ("0" + m.getHours()).slice(-2) + ":" +
        ("0" + m.getMinutes()).slice(-2) + ":" +
        ("0" + m.getSeconds()).slice(-2);
      this.file.PostDate = dateString;
			if (this.fileData && this.fileData.FileID > 0) {
				this.file = this.fileData;
			}
			this.getInitialData();
		},
	}
</script>

<style scoped>

	.el-select {
		width: 50%;
	}
	.country.el-select {
		width: 100%;
	}
	table thead tr th:last-child {
		text-align: center;
	}
	.id {
		padding-top: 6px;
	}
	.delete{
		padding-top: 10px;
	}
	.el-input.Value, .el-input.Name {
		width: 40%;
		margin-bottom: 5px;
	}
	.el-input.Sort {
		width: 10%;
		margin-bottom: 5px;
		text-align:center;
	}
	.heading.Value, .heading.Name {
		width: 40%;
		margin-bottom: 5px;
		text-align: center;
		display: inline-block;
	}
	.heading.Sort {
		width: 10%;
		margin-bottom: 5px;
		text-align: center;
		display: inline-block;
	}
	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 100%;
		position: absolute;
		cursor: pointer;
		left:0;
		top:0;
	}
	.SampleURL {
		width: 35px;
		height: 50px;
		background: #FFFFFF left center no-repeat;
		background-size: contain;
		cursor: pointer;
	}

	.FullURL {
		width: 50px;
		height: 75px;
		background: #FFFFFF left center no-repeat;
		background-size: contain;
		cursor: pointer;
	}

	#fileuploads .audiofile .success_upload {
		border: 4px solid #28a745;
	}
	#fileuploads .audiofile .failed_upload {
		border: 4px solid #dc3545;
	}
	.removeaudio {
		font-size: 14px;
		cursor:pointer;
		position: absolute;
		top: 0;
		background: #FFF;
		color: #666;
		padding: 0px;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		line-height: 9px;
	}
	.removeaudio.sample {
		left: 20px;
	}
	.removeaudio.full {
		left: 35px;
		top: 10px;
	}
    .json {
        font-size:12px;
        line-height: 12px;
    }
</style>
